import SelfFundedOfferDetailsV2 from 'features/rewards/SelfFundedOffers/SelfFundedOfferDetailsV2';
import React from 'react';

export default function Page() {
  return <SelfFundedOfferDetailsV2 />;
}
